import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { MultiLanguageModule } from '@/app/multi-language.module';
import { ChartImportStateService } from './chart-import-state.service';
import { HdChartImportPanelComponent } from './hd-chart-import-panel.component';

/**
 * Navbar-chip die zichtbaar wordt zodra een chart-import loopt (voortgang) of
 * afgerond is maar het rapport nog niet bekeken werd. Klikken opent het
 * importpaneel in een eigen dialog, waar de gebruiker zich ook in de app bevindt.
 * Het paneel zelf wordt ge-@defer'd zodat de navbar-bundle licht blijft; alleen
 * de state-service is eager.
 */
@Component({
  selector: 'hd-chart-import-indicator',
  imports: [SharedModule, MultiLanguageModule, HdChartImportPanelComponent],
  templateUrl: './hd-chart-import-indicator.component.html',
  styleUrl: './hd-chart-import-indicator.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HdChartImportIndicatorComponent {
  protected readonly state = inject(ChartImportStateService);

  protected readonly dialogOpen = signal(false);

  protected get visible(): boolean {
    return this.state.running() || this.state.hasUnseenReport();
  }
}
